export default {
    /**
     * Данные компонента
     * @property {Array} markers - маркеры
     * @property {Boolean} isCardVisible - условие рендера карточки
     * @property {Array} cardData - данные карточки
     * @property {Object} cardMarker - данные маркера карточки
     * @property {Object} cardMarkerSelected - выбранные цены маркера карточки
     * @property {MarkerManager} markerManager - менеджер маркеров
     */
    data: () => ({
        markerManager: null,
        markers: [],
        clusters: {},
        markersWithoutPrices: [],
        isCardVisible: false,
        cardData: [],
        cardKitPrices: [],
        cardMarker: {},
        cardMarkerSelected: {},
        markersStatuses: [],
        currentSelectionSideMode: 'default',
        currentSideCheckList: [],
    }),
    methods: {
        onCloseCard() {
            this.isCardVisible = false;
            this.cardMarker = {};
            this.cardData = [];
            this.cardMarkerSelected = {};
            this.$refs.mapView.unsetMarkerClicked();
        },
        /**
         * Получение Id маркеров по id сторон
         * @param targetSideIds
         * @param state
         * @returns {[]}
         */
        getMarkerFoundIdsBySidesInBox(targetSideIds = [], state) {
            let currentSelectedSides = [];
            this.currentSideCheckList.forEach((side) => {
                if(side.checked){
                    currentSelectedSides.push(side.value)
                }
            })
            let markerIds = [];
            const markers = this.markerManager.getMarkers('0')
            markers.forEach((marker) => {
                let {id = null, side_ids: sideIds = []} = marker;
                let countIncludes = 0;
                sideIds.forEach((sideId) => {
                    if(targetSideIds.includes(sideId) && !markerIds.includes(id)){
                        // markerIds.push(id);
                        countIncludes++;
                    }
                })
                 /* Первое условие для снятия выделения, второе для выделения */
                 if(
                     !currentSelectedSides.length && countIncludes && state === 1
                     || countIncludes && state === 0
                 ){
                     markerIds.push(id);
                 }
            });
            return markerIds;
        },
        /**
         * Получение id маркеров конструкций без цен по id сторон
         * @param targetSideIds
         * @param state
         * @returns {[]}
         */
        getMarkerWPIdsBySidesInBox(targetSideIds = [], state) {
            let markerIds = [];
            let currentSelectedSides = [];
            this.currentSideCheckList.forEach((side) => {
                if(side.checked){
                    currentSelectedSides.push(side.value)
                }
            })

            const markers = this.markerManager.getMarkersWithoutPrices()
            markers.forEach((marker) => {
                let {id = null, catalog_sides: catalogSides = {}} = marker;
                let countIncludes = 0;
                Object.values(catalogSides).forEach((sideId) => {
                    if(targetSideIds.includes(sideId) && !markerIds.includes(id)){
                        countIncludes++;
                    }
                })
                /* Первое условие для снятия выделения, второе для выделения */
                if(
                    !currentSelectedSides.length && countIncludes && state === 1
                    || countIncludes && state === 0
                ){
                    markerIds.push(id);
                }
            });
            return markerIds;
        },
    }
}
